import { Breadcrumb } from '@/context/breadcrumbContext'

export const retainBreadcrumbs = (
  asPath: string,
  toUrl: string,
  currentNavItemPath = '',
  crumbs: Breadcrumb[]
): Breadcrumb[] => {
  const currentUrlChunks = asPath
    .replace(currentNavItemPath, '')
    .split('/')
    .filter((c) => !!c.length)

  const toUrlChunks = toUrl
    .replace(currentNavItemPath, '')
    .split('/')
    .filter((c) => !!c.length)

  const crumbsToKeep = crumbs.reduce((acc, crumb, index) => {
    if (currentUrlChunks[index] === toUrlChunks[index]) {
      acc.push(crumb)
    }
    return acc
  }, [] as Breadcrumb[])

  return crumbsToKeep
}
